import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {TimeRange} from '../models';
import {formatTime} from '../utils';
import {VideoElementStore} from './VideoElementStore';
import {VideoProgressStore} from './VideoProgressStore';

interface Props {
  store: VideoProgressStore,
  updateVideo?: VideoElementStore,
  className?: string;
}


function percent(value: number) {
  return (100 * value).toFixed(2) + '%';
}

function currentTimeStyle(currentTime: number, duration: number, isStudent: boolean = false) {
  if (isStudent) {
    return {
      width: duration === 0 ? '0' : percent((currentTime - 0.8) / duration)
    };
  } else {
    return {
      width: duration === 0 ? '0' : percent(currentTime / duration)
    };
  }
}

function bufferedSegmentStyle(range: TimeRange, duration: number) {
  return {
    left: percent(range.start / duration),
    width: percent((range.end - range.start) / duration)
  };
}

function preventContextMenu(event: React.MouseEvent) {
  event.preventDefault();
}

@observer
export class VideoProgress extends React.Component<Props> {
  readonly progressElement = React.createRef<HTMLDivElement>();

  render() {
    const store = this.props.store;

    const classname = classNames('video-progress-container', this.props.className);

    return (
      <>
        <div className="video-time">
          <span>{formatTime(store.currentTime > 1 && this.props.className == 'student-progress' ? store.currentTime - 0.8 : store.currentTime)}</span><span>{formatTime(store.duration)}</span>
        </div>

        <div className={classname}
             ref={this.progressElement}
             onContextMenu={preventContextMenu}>

          {
            store.canShowProgress &&
            store.buffered.map(range =>
              <div key={range.start}
                   className="buffered-range"
                   style={bufferedSegmentStyle(range, store.duration)}/>
            )
          }

          {
            store.draggingTime === null &&
            <div className="current-time"
                 style={currentTimeStyle(store.currentTime, store.duration, this.props.className == 'student-progress')}>
              <span className="playerHolder"/>
            </div>
          }

          {
            store.draggingTime !== null &&
            <div className="current-time"
                 style={currentTimeStyle(store.draggingTime, store.duration)}>
              <span className="playerHolder"/>
            </div>
          }
        </div>
      </>
    );
  }

  componentDidMount() {
    const videoStore = this.props.updateVideo;
    if (videoStore === null || videoStore === undefined)
      return;
    this.props.store.updateCurrentTimeOnDrag(videoStore, this.progressElement.current!);
  }
}
